import React from "react"
import { AutoSizer } from "react-virtualized"
import { FixedSizeGrid as Grid } from "react-window"
import { useMediaQuery } from "react-responsive"
import { CloseGreenIcon } from "../ImageComponents"
import manejeCover from "../../assets/img/manejecover.png"
import "./styles.scss"

const CardsSelecteds = ({ item, handleClick, hasRemoveIcon }) => {
  const Image = item?.image ? `url(${item?.image})` : `url(${manejeCover})`
  return (
    <div className="card-selected-container">
      <div className="card-selected" style={{ backgroundImage: Image, backgroundSize: "cover" }}>
        <div className="card-selected__header">
          {hasRemoveIcon && <button className="card-selected__header-close" onClick={() => handleClick(item.value)}>
            <CloseGreenIcon />
          </button>}
        </div>
      </div>
    </div>
  )
}

const Cell = ({ data, style, handleClick, hasRemoveIcon }) => {
  return (
    <div style={style} className="cell-grid">
      <CardsSelecteds item={data} handleClick={handleClick} hasRemoveIcon={hasRemoveIcon} />
    </div>
  )
}

const getIdByGridPosition = (col, row) => row * 2 + col

const ItemCardGrid = ({ items, handleClick, hasRemoveIcon = true }) => {
  const grid = {
    cols: 0,
  }

  const S = useMediaQuery({ query: "(min-width:380px)" })
  const M = useMediaQuery({ query: "(min-width:768px)" })
  const L = useMediaQuery({ query: "(min-width:1280px)" })

  if (L || M) {
    grid.cols = 2
  } else if (S) {
    grid.cols = 1
  } else {
    grid.cols = 2
  }

  return (
    <AutoSizer>
      {({ height, width }) => (
        <Grid
          columnCount={grid.cols}
          columnWidth={width / grid.cols}
          height={height}
          rowCount={30}
          overscanRowCount={20}
          rowHeight={grid.cols == 1 ? 230 : 175}
          width={width + 10}
          className={items.length > 4 ? "scroll-card-modal" : "no-scroll"}>
          {({ columnIndex, rowIndex, style }) => {
            const id = getIdByGridPosition(columnIndex, rowIndex)
            if (!items || items.length === 0 || id >= items.length) return null
            return <Cell data={{ ...items[id] }} style={style} handleClick={handleClick} hasRemoveIcon={hasRemoveIcon}/>
          }}
        </Grid>
      )}
    </AutoSizer>
  )
}

export default ItemCardGrid
